"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDependenciesInfoHook = void 0;

var react_1 = require("react");

var equality_1 = require("./equality");

exports.createDependenciesInfoHook = function (areDepsEqual) {
  if (areDepsEqual === void 0) {
    areDepsEqual = equality_1.depsShallowEqual;
  }

  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var stableVersionRef = react_1.useRef(0);
    var versionRef = react_1.useRef(1);
    var lastArgsRef = react_1.useRef(args);

    var getVersion = function getVersion() {
      return versionRef.current;
    };

    var getStableVersion = function getStableVersion() {
      return stableVersionRef.current;
    };

    var unsafelyIncrementVersion = function unsafelyIncrementVersion() {
      versionRef.current++;
    };

    var isLastVersion = function isLastVersion(version) {
      return version === versionRef.current;
    };

    var isStableVersion = function isStableVersion(version) {
      if (typeof version === "undefined") {
        return stableVersionRef.current === versionRef.current;
      }

      return version === stableVersionRef.current;
    };

    var setAsStable = function setAsStable(version) {
      if (typeof version === "undefined") {
        stableVersionRef.current = versionRef.current;
      } else {
        stableVersionRef.current = version;
      }
    };

    var equalsLastDependencies = function equalsLastDependencies() {
      var currentArgs = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        currentArgs[_i] = arguments[_i];
      }

      return areDepsEqual(lastArgsRef.current, currentArgs);
    };

    if (!equalsLastDependencies.apply(void 0, args)) {
      versionRef.current++;
      lastArgsRef.current = args;
    }

    var getLastDependencies = function getLastDependencies() {
      return lastArgsRef.current;
    };

    return react_1.useRef({
      getVersion: getVersion,
      getStableVersion: getStableVersion,
      getLastDependencies: getLastDependencies,
      isLastVersion: isLastVersion,
      isStableVersion: isStableVersion,
      setAsStable: setAsStable,
      equalsLastDependencies: equalsLastDependencies,
      unsafelyIncrementVersion: unsafelyIncrementVersion
    }).current;
  };
};